@if (isCloudZiti) {
  <div>
    @if (brandingService.darkModeEnabled) {
      <link href="/assets/styles/dark.css" rel="stylesheet" type="text/css" />
    }
    @if (brandingService.darkModeEnabled) {
      <link href="/assets/styles/darkmode.css" rel="stylesheet" type="text/css" />
    }
  </div>
}
